<template>
	<div>
		{{ findArticle }}
		<v-row>
			<v-col cols="12" class="pb-0" v-if="Colors.length">
				<v-alert type="info" text prominent>
					El tono del color puede varea en base a las características
					de la pantalla de su dispositivo.
				</v-alert>
			</v-col>

			<v-col cols="12" class="pb-0" v-if="Colors.length">
				<v-select
					dense
					outlined
					clearable
					label="Color"
					:items="Colors"
					v-model="ui.filters.color_id"
				>
					<template
						v-slot:item="{
							item,
						}"
					>
						<div
							style="width: 100%;"
							class="d-flex align-center justify-space-between"
						>
							<small>
								{{ item.text }}
							</small>
							<ColorBlock
								:hex="item.color.hex"
								size="25"
							></ColorBlock>
						</div>
					</template>
				</v-select>
			</v-col>

			<v-col
				cols="12"
				md="12"
				class="pb-0 pt-0"
				v-if="Contents.length > 1"
			>
				<v-select
					dense
					outlined
					clearable
					label="Contenido"
					:items="Contents"
					v-model="ui.filters.contents"
				></v-select>
			</v-col>

			<v-col
				md="12"
				cols="12"
				class="pt-0 pb-0"
				v-if="Type_of_finishes.length"
			>
				<v-select
					dense
					outlined
					clearable
					label="Acabado"
					:items="Type_of_finishes"
					v-model="ui.filters.type_of_finish_id"
				></v-select>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { V } from "@/main";
import Sort from "@/clas/Sort";
import Article from "@/clas/Article";
import AmountIputGroup from "@/components/AmountIputGroup";
import ColorBlock from "@/components/Article/Show/ColorBlock";

export default {
	name: "Selector",

	props: ["value", "articles"],

	components: {
		ColorBlock,
		AmountIputGroup,
	},

	data() {
		return {
			v: V,

			ui: {
				filters: {
					color_id: null,
					contents: null,
					type_of_finish_id: null,
				},
			},
		};
	},

	created() {
		console.log(this.articles);
	},

	methods: {
		filteredByTof(articles) {
			return articles.filter(
				(article) =>
					article.type_of_finish_id ==
					this.ui.filters.type_of_finish_id
			);
		},

		filteredByContents(articles) {
			return articles.filter(
				(article) => article.contents == this.ui.filters.contents
			);
		},

		filteredByColors(articles) {
			return articles.filter(
				(article) => article.color_id == this.ui.filters.color_id
			);
		},

		arrayUnique(array, key) {
			if (key) {
				let unique = [];

				let reduced = array.reduce((acc, el) => {
					acc[el.value] = el;
					return acc;
				}, []);

				for (var i in reduced) {
					unique.push(reduced[i]);
				}

				return unique;
			}

			return [...new Set(array)];
		},
	},

	computed: {
		vModel: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit("input", newValue);
			},
		},

		findArticle() {
			let article = null;

			let articles = this.articles;

			// Filter Color
			if (this.ui.filters.color_id) {
				articles = this.filteredByColors(articles);
			}

			// Filter Contents
			if (this.ui.filters.contents) {
				articles = this.filteredByContents(articles);
			}

			// Filter Type_of_finishe
			if (this.ui.filters.type_of_finish_id) {
				articles = this.filteredByTof(articles);
			}

			if (articles.length === 1) {
				article = articles[0];
			}

			this.vModel = article;

			// console.log(articles);
		},

		Colors() {
			let articles = this.articles;

			if (this.ui.filters.type_of_finish_id) {
				articles = this.filteredByTof(articles);
			}

			if (this.ui.filters.contents) {
				articles = this.filteredByContents(articles);
			}

			let colors = articles
				.filter((item) => item.color)
				.map((item) => {
					return {
						text: item.color.name,
						value: item.color.id,
						color: item.color,
					};
				});

			colors = this.arrayUnique(colors, "value");

			// Sort by color name desc
			let sort = new Sort(colors);
			colors = sort.descByAtribute("name");

			if (colors.length == 1) {
				this.ui.filters.color_id = colors[0].value;
			}

			return colors;
		},

		Contents() {
			let articles = this.articles;

			let contents_availables = articles.map(
				(article) => article.contents
			);

			let contents = [];

			if (this.ui.filters.color_id) {
				articles = this.filteredByColors(articles);

				contents_availables = articles.map(
					(article) => article.contents
				);
			}

			contents = articles.map((item) => {
				const a = new Article(item);

				return {
					text: a.netContent(),
					value: `${item.contents}`,
					disabled: contents_availables.find(
						(content_available) =>
							content_available == item.contents
					)
						? false
						: true,
				};
			});

			contents = this.arrayUnique(contents, "value");

			if (contents.length == 1) {
				this.ui.filters.contents = contents[0].value;
			}

			return contents;
		},

		Type_of_finishes() {
			let articles = this.articles;
			let type_of_finishes = [];

			if (this.ui.filters.color_id) {
				articles = this.filteredByColors(articles);
			}

			type_of_finishes = articles
				.filter((item) => item.type_of_finish)
				.map((item) => {
					return {
						text: `${item.type_of_finish.name}`,
						value: item.type_of_finish.id,
					};
				});

			type_of_finishes = this.arrayUnique(type_of_finishes, "value");

			if (type_of_finishes.length == 1 && this.ui.filters.color_id) {
				this.ui.filters.type_of_finish_id = type_of_finishes[0].value;
			}

			return type_of_finishes;
		},
	},
};
</script>

<style lang="css" scoped></style>
